import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { useHistory, useParams } from 'react-router-dom'
import ReactLoader from 'react-loader'
import { BACKEND_URL_PREFIX, OKIN_OPTIONS } from '../../../../utils/const'
import { buildDefaultHeaders } from '../../../../actions/helper'
import { useSelector } from 'react-redux'

import Header from '../Structure/Header'

import EnrollYears from './EnrollYears'
import CorrespondenceTable from './CorrespondenceTable'

const ConditionsCompliance = () => {
  const history = useHistory()
  const { id } = useParams()
  const state = useSelector(state => state)

  const [years, setYears] = useState([])
  const [syid, setSyid] = useState(null)
  const [data, setData] = useState(null)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const [activeTab, setActiveTab] = useState('conditions_compliance')

  useEffect(() => {
    const fetchYears = async () => {
      setLoading(true)
      setData(null)
      setError('')
      try {
        const response = await fetch(
          `${BACKEND_URL_PREFIX}/epcr/enroll_years/${id}`,
          buildDefaultHeaders({ auth: state.auth })
        )

        if (response.ok) {
          const result = await response.json()
          setYears(result)
          setSyid(result[0]?.syid ?? null)
          if (!result.length) setError('По направлению нет действующих учебных групп')
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
      setLoading(false)
    }

    fetchYears()
  }, [id])

  useEffect(() => {
    if (!syid) return

    const fetchData = async () => {
      setLoading(true)
      setError('')
      try {
        const response = await fetch(
          `${BACKEND_URL_PREFIX}/epcr/conditions_compliance/${id}/${syid}`,
          buildDefaultHeaders({ auth: state.auth })
        )

        const result = await response.json()

        if (response.ok) {
          setData(result)
        } else {
          setData(null)
          setError(result?.error || 'Не удалось получить данные')
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
      setLoading(false)
    }

    fetchData()
  }, [id, syid])

  const goBack = () => {
    history.push('/dashboard_new/edu_prog')
  }

  const { program_name, accordance, okin_id } = data || {}

  return (
    <div className={styles.wrapper}>
      <Header
        title={program_name}
        levelStudy={OKIN_OPTIONS.find(item => item.value === okin_id)?.label}
        onBack={goBack}
        accordance={accordance}
        general={null}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      >
        <EnrollYears years={years} activeSyid={syid} onChange={setSyid} />
      </Header>

      <ReactLoader loaded={!loading} color='#5b76e5'>
        {error && <div className={styles.error}>{error}</div>}
        {data && <CorrespondenceTable data={data} />}
      </ReactLoader>
    </div>
  )
}

export default ConditionsCompliance
